import { CSSProperties, useEffect, useRef, useState } from 'react';
import { widont } from 'utils/typography';
import { DefaultBlockProps } from '../switchBlock/SwitchBlock';
import style from './TextBlock.module.scss';

export type BlocksTextType = DefaultBlockProps & {
  block_type: 'text';
  // text_position: 'left' | 'right' | undefined;
  text: string;
};

export const TextBlock = ({ text }: BlocksTextType): JSX.Element => {
  const textClass = style.text;
  const htmlRef = useRef<HTMLDivElement>(null);
  const [inlineStyles, setInlineStyles] = useState<CSSProperties | undefined>(undefined);
  useEffect(() => {
    const iframe = htmlRef.current?.querySelector('iframe');
    if (iframe) {
      const w = parseInt(iframe.getAttribute('width') || '0', 10);
      const h = parseInt(iframe.getAttribute('height') || '0', 10);
      const ratio = w / h;

      // could be contained in a P tag
      const parent = iframe.parentElement;
      if (parent) {
        parent.style.height = '100%';
      }

      setInlineStyles({
        width: '100%',
        height: 'auto',
        aspectRatio: `${ratio}`,
      });
    }
  }, [htmlRef.current]);

  return (
    <div className={`${style.container} block-text`}>
      {/* Add h2 in the html to style a "heading" */}
      <div
        className={textClass}
        style={inlineStyles}
        ref={htmlRef}
        dangerouslySetInnerHTML={{ __html: widont(text) }}
      />
    </div>
  );
};
